module.exports = __webpack_public_path__ + "img/14.e12028f7.jpg";